module.exports = __webpack_public_path__ + "static/media/Intro_zu_Archiven_HP.1a9e0e41.pdf";